import React from 'react';
import ReactDOM from 'react-dom';
import PortrushDreamgetaway from '../pages/PortrushDreamgetaway';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <PortrushDreamgetaway />,
    document.body.appendChild(document.createElement('div')),
  )
});